import { useContext } from 'react'
import { CashierContext } from '@/contexts'

export const useCashier = () => useContext(CashierContext)
